'use client';

import { useEffect, useState } from 'react';

import { fetchPclAirports } from '../actions/hook-proxies/pcl-airports';

import type { PclAirportCollection } from '..';
import type { Locale } from '@tuic/i18n';

type UsePclAirportsParams = {
  locale: Locale;
};

export type UsePclAirports = {
  pending: boolean;
  airports: PclAirportCollection;
};

/**
 * Use the PCL airports on the client.
 */
export const usePclAirports = ({
  locale,
}: UsePclAirportsParams): UsePclAirports => {
  const [pending, setPending] = useState(true);
  const [airports, setAirports] = useState<PclAirportCollection>({});

  useEffect(() => {
    if (!pending) {
      return;
    }

    const exec = async () => {
      setAirports(await fetchPclAirports(locale));
      setPending(false);
    };

    exec();
  }, [pending]);

  return {
    pending,
    airports,
  };
};
